let CURRENT_ID = 0;
function generateId(): number {
  return ++CURRENT_ID;
}

export function createDividual(): Dividual {
  return {id: generateId(), name: '', ratio: 1, comfort: 1};
}

export function duplicateDividual(dividual: Dividual): Dividual {
  return {...dividual, id: generateId()}
}

export function createEstate(): Estate {
  return {id: generateId(), name: '', dividuals: [createDividual()]};
}

export function duplicateEstate({name, dividuals}: Estate): Estate {
  return {
    name,
    dividuals: dividuals.map(duplicateDividual),
    id: generateId()
  };
}
